module.exports = __webpack_public_path__ + "img/logo-branco-raia copy.dfc0cf43.svg";